import { useState } from 'react'

import AuctionStatus from '../components/AuctionStatus'

import css from './sass/auctionscards.module.scss'
import themeCss from '../components/sass/theme.module.scss'

export default function AuctionCountdown( { auctionDetail, isCheckedIn, auctionState, isBrowse } ) {

  const [countdown, setCountdown] = useState('')

  const updateCountdown = (timeString) => {
    setCountdown(timeString)
  }

  return (
    <>
      <AuctionStatus auction={auctionDetail} updateCountdown={updateCountdown} />
      {(auctionState === 'before' && (isBrowse === true || isCheckedIn === true)) && (
        <div className={themeCss['box-left-yellow-accent-content']}>
          <p className={css['countdown-timer']}>Auction starts in {countdown}</p>
        </div>)}

      {auctionState === 'started' && (
        <div className={themeCss['box-left-yellow-accent-content']}>
          <p className={css['countdown-timer']}>Auction ends in {countdown}</p>
        </div>)}

      {auctionState === 'ended' && (
        <div className={themeCss['box-left-yellow-accent-content']}>
          <p className={css['countdown-over']}>Auction has ended.</p>
        </div>)}
    </>
  )
}